module.exports = __webpack_public_path__ + "img/coach_lock.759e0778.svg";